import React, {FC, useEffect, useLayoutEffect, useMemo, useRef} from 'react';

import arrow from 'assets/svg/matchcenter_tabs_arrow.svg';
import useBreakpointLG from 'hooks/useBreakpointLG';
import CustomScrollMenu from 'components/Common/CustomScrollMenu';
import './styles.scss';
import useSportFilter from 'hooks/useSportFilter';
import {sportNames} from 'utils/sportsUtils';
import useDateTabs from 'hooks/useDateTabs';

const SportsTabs: FC = () => {
  const tabsRef = useRef<CustomScrollMenu | null>(null);
  const isBreakpointLG = useBreakpointLG();
  const [sportFilterStateValues, {setSportFilter}] = useSportFilter();
  const {filter} = sportFilterStateValues;

  const [
    {tabsType: dateTabsType, tabs: dateTabs, selectedTabIndex: dateTabIndex},
    {setDateTabsType, setSelectedDateTab},
] = useDateTabs();

  const tabs = useMemo(() => {
    return [{sport: 'top', slug: 'top', name: 'ΟΛΑ ΤΑ ΣΠΟΡ'}, ...sportNames].map(s => (
      <button
        className="SportsTabs__tab"
        type="button"
        key={s.sport}
      >
        <span className="SportsTabs__label">{s.name}</span>
      </button>
    ));
  }, []);

  useEffect(() => {
    if (tabsRef.current) {
      const middleIndex = Math.ceil((tabs.length - 2) / 2);
      tabsRef.current.scrollTo(`${tabs[0].key}`);
    }
  }, [tabsRef, tabs]);

  return (
    <CustomScrollMenu
      ref={tabsRef}
      data={tabs}
      alignCenter
      alignOnResize={false}
      inertiaScrolling
      wheel={false}
      menuClass="SportsTabs"
      selected={filter}
      translate={
        /* FIXME: fix this mess with proper detection of intially selected item */
        -1 * (tabs.length / 2) * (isBreakpointLG ? 90 : 80) +
        (isBreakpointLG ? 354 : window.innerWidth / 2)
      }
      onSelect={key => {
        if (!key || !tabsRef.current) return;

        setSportFilter(`${key}`);
        tabsRef.current.scrollTo(`${key}`);
        setSelectedDateTab(14)
      }}
    />
  );
};

export default React.memo(SportsTabs);
